export const Z_INDEX_QUESTION = 1
export const Z_INDEX_HEADER = 2
export const Z_INDEX_OVERLAY = 5
export const Z_INDEX_MODAL = 10
export const Z_INDEX_LOADING = 15
